import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import models.GameRepository

class BankoStartScreenViewModel(
    gameRepository: GameRepository,
    playerPreferences: PlayerPreferences
) : ViewModel() {

    private val bankoStartScreenUseCase =
        BankoStartScreenUseCase(gameRepository, viewModelScope, playerPreferences)
    val bankoStartScreenUiState = bankoStartScreenUseCase()
}
